export default __webpack_public_path__ + "static/media/Acolyte's Leggings of the Black Thread.8c04809e.jpg";